import  NavMenu from '../../components/NavMenu';

const Header = ():JSX.Element => {
  return (
    <>
      <NavMenu/>
    </>
  );
}

export default Header;